import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { Factory, Award, BadgeCheck, Flag, Heart } from 'lucide-react';

const ManufacturingSection = () => {
  const { t } = useLanguage();

  return (
    <section className="section-spacing" data-testid="manufacturing-section">
      <div className="container-custom">
        <h2 
          className="text-3xl md:text-5xl font-bold text-[#0047AB] text-center mb-4"
          data-testid="manufacturing-title"
        >
          {t('manufacturingTitle')}
        </h2>
        <div className="section-divider mb-12"></div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Manufacturing Facility */}
          <div className="bg-white p-8 shadow-md border-l-4 border-[#0047AB]" data-testid="facility-card">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 bg-[#0047AB]/10 flex items-center justify-center">
                <Factory className="w-7 h-7 text-[#0047AB]" />
              </div>
              <h3 className="text-2xl font-bold text-slate-800">{t('facilityTitle')}</h3>
            </div>
            <p className="text-slate-600 leading-relaxed">{t('facilityDesc')}</p>
            
            {/* Facility image */}
            <div className="mt-6 aspect-video bg-slate-50 overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_gupta-grih-udyog/artifacts/nwlqc5tk_9%20Facility%20Image%20Placeholder.png" 
                alt="Gupta Soap Grih Udyog Manufacturing Facility"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Certifications */}
          <div className="bg-white p-8 shadow-md border-l-4 border-amber-500" data-testid="certifications-card">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 bg-amber-500/10 flex items-center justify-center">
                <Award className="w-7 h-7 text-amber-500" />
              </div>
              <h3 className="text-2xl font-bold text-slate-800">{t('certificationsTitle')}</h3>
            </div>
            
            <div className="space-y-4">
              {/* ISO Certification */}
              <div className="flex gap-4 p-4 bg-slate-50">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-[#0047AB] flex items-center justify-center">
                    <BadgeCheck className="w-6 h-6 text-white" />
                  </div>
                </div>
                <div>
                  <h4 className="font-bold text-slate-800 mb-1">ISO 9001:2015</h4>
                  <p className="text-sm text-slate-600">{t('isoDesc')}</p>
                </div>
              </div>

              {/* ZED Certification */}
              <div className="flex gap-4 p-4 bg-slate-50">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-green-600 flex items-center justify-center">
                    <BadgeCheck className="w-6 h-6 text-white" />
                  </div>
                </div>
                <div>
                  <h4 className="font-bold text-slate-800 mb-1">MSME ZED</h4>
                  <p className="text-sm text-slate-600">{t('zedDesc')}</p>
                </div>
              </div>

              {/* Made in India */}
              <div className="flex gap-4 p-4 bg-slate-50">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-orange-500 flex items-center justify-center">
                    <Flag className="w-6 h-6 text-white" />
                  </div>
                </div>
                <div>
                  <h4 className="font-bold text-slate-800 mb-1">{t('madeInIndia')}</h4>
                  <p className="text-sm text-slate-600">{t('madeInIndiaDesc')}</p>
                </div>
              </div>

              {/* Vocal for Local */}
              <div className="flex gap-4 p-4 bg-slate-50">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-red-500 flex items-center justify-center">
                    <Heart className="w-6 h-6 text-white" />
                  </div>
                </div>
                <div>
                  <h4 className="font-bold text-slate-800 mb-1">{t('vocalForLocal')}</h4>
                  <p className="text-sm text-slate-600">{t('vocalForLocalDesc')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ManufacturingSection;
